import React from 'react';

import { NewEmail } from '@/components/emailWindow/components/newEmail/NewEmail.comp.tsx';
import { useAppConfig } from '@/contexts/appConfig/AppConfig.context.ts';
import { useNewEmailIsFloatingWindow } from '@/views/emails/context/NewEmails.ts';

export const EmailWindow: React.FC = () => {
  const { isEmailEnabled } = useAppConfig();
  const isFloatingWindow = useNewEmailIsFloatingWindow();

  if (!isEmailEnabled || !isFloatingWindow) {
    return null;
  }
  return <NewEmail />;
};
